import axios from 'axios'

export default {
  // 引擎--新增|修改|删除aspera账号
  addOrUpdateAsperaAccounts (params) {
    return axios.post('/api/rendering/admin/task/engine/addOrUpdateAsperaAccounts', params)
  },
  // 引擎--查询aspera账号
  queryAsperaAccounts () {
    return axios.post('/api/rendering/admin/task/engine/queryAsperaAccounts')
  },
  // 引擎--新增|修改线路
  addOrUpdateEngineLine (params) {
    return axios.post('/api/rendering/admin/task/engine/addOrUpdateEngineLine', params)
  },
  // 引擎--查询线路列表
  queryEngineLines (params) {
    return axios.post('/api/rendering/admin/task/engine/queryEngineLines', params)
  },
  // 引擎--删除线路
  deleteEngineLine (params) {
    return axios.post('/api/rendering/admin/task/engine/deleteEngineLine', params)
  },
  // 引擎--配置线路
  addOrUpdateTaskEngineLine (params) {
    return axios.post('/api/rendering/admin/task/engine/addOrUpdateTaskEngineLine', params)
  },
  // 引擎--新增引擎
  addTaskEngine (params) {
    return axios.post('/api/rendering/admin/task/engine/addTaskEngine', params)
  },
  // 引擎--删除引擎
  deleteEngine (params) {
    return axios.post('/api/rendering/admin/task/engine/deleteEngine', params)
  },
  // 修改引擎属性|设置默认
  updateTaskEngine (params) {
    return axios.post('/api/rendering/admin/task/engine/updateTaskEngine', params)
  },
  // 引擎--根据引擎ID查询引擎线路绑定
  queryEngineLineInfo (params) {
    return axios.post('/api/rendering/admin/task/engine/queryEngineLineInfo', params)
  },
  // 引擎--查询引擎列表
  queryEngines (params) {
    return axios.post('/api/rendering/admin/task/engine/queryEngines', params)
  },
  // 网页端-获取单个线路
  getLineWeb (params) {
    return axios.post('/api/rendering/admin/task/page/transmit/getLine', params)
  },
  // 网页端-添加线路
  addLineWeb (params) {
    return axios.post('/api/rendering/admin/task/page/transmit/addLine', params)
  },
  // 网页端-更新线路
  updateLineWeb (params) {
    return axios.post('/api/rendering/admin/task/page/transmit/updateLine', params)
  },
  // 网页端-删除线路
  deleteLineWeb (params) {
    return axios.post('/api/rendering/admin/task/page/transmit/deleteLine', params)
  },
  // 网页端-查询线路列表
  queryLineListWeb (params) {
    return axios.post('/api/rendering/admin/task/page/transmit/queryLineList', params)
  },
  // HTTP-添加线路
  addLineHttp (params) {
    return axios.post('/api/rendering/admin/task/http/addHttpLines', params)
  },
  // HTTP-更新线路
  updateLineHttp (params) {
    return axios.post('/api/rendering/admin/task/http/editHttpLines', params)
  },
  // HTTP-删除线路
  deleteLineHttp (params) {
    return axios.post('/api/rendering/admin/task/http/deleteHttpLines', params)
  },
  // HTTP-查询线路列表
  queryLineListHttp (params) {
    return axios.post('/api/rendering/admin/task/http/queryHttpLines', params)
  },
  // VPN-添加/更新 线路
  addOrUpdateVpnLines (params) {
    return axios.post('/api/rendering/admin/task/mount/path/addOrUpdateVpnLines', params)
  },
  // VPN-删除线路
  deleteLineVpn (params) {
    return axios.post('/api/rendering/admin/task/mount/path/deleteVpnLines', params)
  },
  // VPN-查询线路列表
  queryVpnLines (params) {
    return axios.post('/api/rendering/admin/task/mount/path/queryVpnLines', params)
  },
  // 添加aspera账户 /api/rendering/admin/task/aspera/addAspera
  addAspera (params) {
    return axios.post('/api/rendering/admin/task/aspera/addAspera', params)
  },
  // 查询aspera账户 /api/rendering/admin/task/aspera/queryAsperas
  queryAsperas (params) {
    return axios.post('/api/rendering/admin/task/aspera/queryAsperas', params)
  },
  // /api/rendering/admin/task/aspera/queryAsperaIps
  queryAsperaIps (params) {
    return axios.post('/api/rendering/admin/task/aspera/queryAsperaIps', params)
  },
  // /api/rendering/admin/task/aspera/addAsperaIp
  addAsperaIp (params) {
    return axios.post('/api/rendering/admin/task/aspera/addAsperaIp', params)
  },
  // /api/rendering/admin/task/aspera/deleteAsperaIp
  deleteAsperaIp (params) {
    return axios.post('/api/rendering/admin/task/aspera/deleteAsperaIp', params)
  },
  // /api/rendering/admin/task/aspera/deleteAspera
  deleteAspera (params) {
    return axios.post('/api/rendering/admin/task/aspera/deleteAspera', params)
  },
  // /api/rendering/admin/task/aspera/updateAsperaIp
  updateAsperaIp (params) {
    return axios.post('/api/rendering/admin/task/aspera/updateAsperaIp', params)
  },
  // /api/rendering/admin/task/aspera/updateAspera
  updateAspera (params) {
    return axios.post('/api/rendering/admin/task/aspera/updateAspera', params)
  },
  // 标记账户类型
  markAccountType (params) {
    return axios.post('/api/rendering/admin/task/aspera/markAccountType', params)
  },
}
